import { styled } from '@mui/material/styles';
import Image from 'next/image';

type SpacingValue = number | string | undefined;

const formatSpacing = (value: SpacingValue) => {
  if (value === undefined) return undefined;
  return typeof value === 'number' ? `${value}px` : value;
};

export const ImageStyled = styled(Image)<{
  fill?: boolean;
  width?: number | string;
  height?: number | string;
  m?: SpacingValue;
  mt?: SpacingValue;
  mb?: SpacingValue;
  ml?: SpacingValue;
  mr?: SpacingValue;
  mx?: SpacingValue;
  my?: SpacingValue;
}>`
  width: ${({ width }) => (width ? `${width}px` : 'auto')};
  height: ${({ height, fill }) => (fill || !height ? 'auto' : `${height}px`)};
  ${({ m }) => m !== undefined && `margin: ${formatSpacing(m)};`}
  ${({ mt, my }) => (mt ?? my) !== undefined && `margin-top: ${formatSpacing(mt ?? my)};`}
  ${({ mb, my }) => (mb ?? my) !== undefined && `margin-bottom: ${formatSpacing(mb ?? my)};`}
  ${({ ml, mx }) => (ml ?? mx) !== undefined && `margin-left: ${formatSpacing(ml ?? mx)};`}
  ${({ mr, mx }) => (mr ?? mx) !== undefined && `margin-right: ${formatSpacing(mr ?? mx)};`}
`;
